var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-5 step-2",attrs:{"data-aos":"fade-up","data-aos-duration":"2000"}},[_c('b-form-checkbox',{attrs:{"id":"checkbox-1"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('a',{attrs:{"href":"/agreement"}},[_c('span',[_vm._v("本人已閱讀並同意上敘條款")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }